import { Box } from 'reflexbox';
import styled, { css } from 'styled-components';

import { Breakpoint } from '@treams/treams-ui';

/**
 * Apple-style scrollbar: thin, rounded, no track, only visible while hovering
 * the scroll container. `scrollbar-color` covers Firefox and Chrome; the
 * `::-webkit-scrollbar` rules cover Safari.
 */
const appleScrollbar = css`
	scrollbar-width: thin;
	scrollbar-color: transparent transparent;

	&:hover {
		scrollbar-color: rgba(0, 0, 0, 0.25) transparent;
	}

	&::-webkit-scrollbar {
		width: 8px;
	}
	&::-webkit-scrollbar-track {
		background: transparent;
	}
	&::-webkit-scrollbar-thumb {
		background: transparent;
		border-radius: 8px;
		background-clip: padding-box;
		border: 2px solid transparent;
	}
	&:hover::-webkit-scrollbar-thumb {
		background-color: rgba(0, 0, 0, 0.25);
	}
	&::-webkit-scrollbar-thumb:hover {
		background-color: rgba(0, 0, 0, 0.4);
	}
`;

/**
 * A pane that scrolls on its own on desktop and lets the page scroll on
 * mobile. Shared by the split content and the sidebar list.
 */
const TalentReviewScrollPane = styled(Box)`
	min-height: 0;
	overflow-x: hidden;
	overflow-y: auto;
	overscroll-behavior: contain;
	${appleScrollbar}

	@media screen and (max-width: ${Breakpoint.Medium}) {
		overflow: visible;
	}
`;

export default TalentReviewScrollPane;
